module.exports = __webpack_public_path__ + "static/media/air.cbec451b.svg";